// import "jquery-ui/ui/widgets/selectable"
import "jquery-contextmenu";
import { saveAs } from "file-saver";
import Mousetrap from "mousetrap";
import { validFilename, getFolderNameSuggestion } from "./utils";
import { addTrail } from "./trail";
import propertiesView from "./views/node_properties.html";
import Tabs from "./tabs";
import hyperHTML from "hyperhtml";

export default (function() {
  /**
   * @function ContextMenu
   */
  function ContextMenu() {
    this.init();
  }

  ContextMenu.prototype.init = function() {
    // click on the tephra folder
    $.contextMenu({
      selector: ".fancytree-folder.tephra",
      items: {
        addSnippet: {
          name: "Add Snippet",
          icon: "fa-book"
        },
        createSnippet: {
          name: "Create Snippet",
          icon: "fa-plus-square-o"
        },
        searchFolder: {
          name: "Search This folder",
          icon: "fa-search"
        }
      },
      callback: function(key, options) {
        tree = $.ui.fancytree.getTree("#tree-pane-component");
        const node = ContextMenu.findContextNode(options.$trigger[0]);
        const action = key == "searchFolder" ? "SearchFolder" : key;

        CodeEditor.TephraManager[action](node);
      }
    });

    // Right click on the tephra-family folder
    $.contextMenu({
      selector: ".fancytree-folder.family-snippet",
      items: {
        snippetUsage: {
          name: "Usage",
          icon: "fa-info-circle"
        },
        searchFolder: {
          name: "Search This folder",
          icon: "fa-search"
        }
      },
      callback: function(key, options) {
        let node;
        tree = $.ui.fancytree.getTree("#tree-pane-component");
        node = ContextMenu.findContextNode(options.$trigger[0]);
        switch (key) {
          case "searchFolder":
            CodeEditor.TephraManager.SearchFolder(node);
            break;
          default:
            CodeEditor.TephraManager[key](node);
            break;
        }
      }
    });

    // Right click on the tephra-snippet folder
    $.contextMenu({
      selector: ".fancytree-folder.tephra-snippet",
      items: {
        snippetUsage: {
          name: "Usage",
          icon: "fa-info-circle"
        },
        editSnippet: {
          name: "Modify",
          icon: "fa-pencil-square-o"
        },
        getNodeProperties: {
          name: "Properties",
          icon: "fa-info-circle"
        },
        manageTags: {
          name: "Tags",
          icon: "fa-download"
        },
        // detachSnippet: {
        //   name: "Detach from tree",
        //   icon: "fa-trash-o"
        // },
        deleteSnippet: {
          name: "Delete",
          icon: "fa-trash-o"
        },
        searchFolder: {
          name: "Search This folder",
          icon: "fa-search"
        }
      },
      callback: function(key, options) {
        let node;
        tree = $.ui.fancytree.getTree("#tree-pane-component");
        node = ContextMenu.findContextNode(options.$trigger[0]);
        switch (key) {
          case "manageTags":
            CodeEditor.TephraManager.ManageTags(node);
            break;
          case "getNodeProperties":
            ContextMenu[key](node);
            break;
          case "searchFolder":
            CodeEditor.TephraManager.SearchFolder(node);
            break;
          default:
            CodeEditor.TephraManager[key](node);
            break;
        }
      }
    });

    // click on the tephra-snippet file
    $.contextMenu({
      selector: ".fancytree-node.tephra-snippet:not(.fancytree-folder)",
      items: {
        downloadFromNode: {
          name: "Download",
          icon: "fa-download"
        },
        // manageTags: {
        //   name: "Tags",
        //   icon: "fa-download"
        // },
        fileHistory: {
          name: "File History",
          icon: "fa-clock-o"
        },
        getNodeProperties: {
          name: "Properties",
          icon: "fa-info-circle"
        }
        // 'previewSnippet': {
        //   name: 'Live Preview',
        //   icon: 'fa-eye',
        // },
      },
      callback: function(key, options) {
        tree = $.ui.fancytree.getTree("#tree-pane-component");
        const node = ContextMenu.findContextNode(options.$trigger[0]);
        CodeEditor.Main.fileType(node);
        switch (key) {
          case "downloadFromNode":
          case "manageTags":
            CodeEditor.TephraManager.ManageTags(node);
            break;
          default:
            CodeEditor.ContextMenu[key](node);
            break;
        }
      }
    });

    // click on the file image
    $.contextMenu({
      selector: ".fancytree-node.file-image",
      items: {
        rename: {
          name: "Rename",
          icon: "fa-edit"
        },
        delete: {
          name: "Delete",
          icon: "fa-trash-o"
        }
      },
      callback: function(key, options) {
        let node;
        tree = $.ui.fancytree.getTree("#tree-pane-component");
        // node = tree.getActiveNode();
        node = ContextMenu.findContextNode(options.$trigger[0]);

        switch (key) {
          case "rename":
            ContextMenu.editElement(node);
            break;
          case "delete":
            ContextMenu.deleteElement(node);
            break;
        }
      }
    });

    // click on a file on the tree
    $.contextMenu({
      selector: ".fancytree-node.file",
      items: {
        editElement: {
          name: "Rename",
          icon: "fa-edit"
        },
        deleteElement: {
          name: "Delete",
          icon: "fa-trash-o"
        },
        downloadFromNode: {
          name: "Download",
          icon: "fa-download"
        },
        createFile: {
          name: "New File",
          icon: "fa-file-code-o"
        },
        createFolder: {
          name: "New Folder",
          icon: "fa-folder-open-o"
        },
        fileHistory: {
          name: "File History",
          icon: "fa-clock-o"
        }
      },
      callback: function(key, options) {
        let fileType;
        let node;
        tree = $.ui.fancytree.getTree("#tree-pane-component");
        node = ContextMenu.findContextNode(options.$trigger[0]);
        fileType = CodeEditor.Main.fileType(node);
        switch (key) {
          case "createFile":
            ContextMenu[key](node.parent, fileType);
            break;
          case "createFolder":
            ContextMenu[key](node.parent, fileType);
            break;
          case "downloadFromNode":
            ContextMenu[key](node, fileType);
            break;
          default:
            ContextMenu[key](node);
        }
      }
    });
    const anchor = (url, label, method = "GET") =>
      `<a href="${url}" target="_blank" data-method="${method}">${label}</a>`;
    const SA_SITE_URL = $("[data-super-admin]").attr("data-super-admin");
    // click on the main folder theme
    $.contextMenu({
      selector: ".fancytree-folder.theme",
      items: {
        deploy: {
          name: anchor(`${SA_SITE_URL}/deploys/new`, "Deploy"),
          isHtmlName: true,
          icon: "fa-cube"
        },
        deploys: {
          name: anchor(`${SA_SITE_URL}/deploys`, "All packages"),
          isHtmlName: true,
          icon: "fa-cubes"
        },
        ghost: {
          name: "Ghost Admin",
          icon: "fa-snapchat-ghost",
          items: {
            ghost_dev: {
              name: anchor(`${SA_SITE_URL}/ghosts?env=dev`, "Dev", "POST"),
              isHtmlName: true
            },
            ghost_staging: {
              name: anchor(`${SA_SITE_URL}/ghosts?env=staging`, "Staging", "POST"),
              isHtmlName: true
            },
            ghost_prod: {
              name: anchor(`${SA_SITE_URL}/ghosts?env=production`, "Production", "POST"),
              isHtmlName: true
            }
          }
        },
        separator2: { type: "cm_separator" },
        downloadFromNode: {
          name: "Download",
          icon: "fa-download"
        },
        SearchFolder: {
          name: "Search This Theme",
          icon: "fa-search"
        },
        replaceThemeFiles: {
          name: "Overwrite This Theme",
          icon: "fa-pencil-square-o"
        },
        reloadTree: {
          name: "Refresh The File Tree",
          icon: "fa-refresh"
        }
      },
      callback: (key, options) => {
        let node;
        tree = $.ui.fancytree.getTree("#tree-pane-component");
        node = ContextMenu.findContextNode(options.$trigger[0]);
        console.log(key);
        if (key.match(/deploy|ghost_/)) {
          const anchor = options.$selected.find("a")[0];
          anchor && anchor.click();
          return;
        }
        ContextMenu[key](node);
      }
    });

    // click on the images or fonts folder
    $.contextMenu({
      selector: ".fancytree-folder.image-upload, .fancytree-folder.image-upload + ul li .fancytree-folder",
      items: {
        upload: {
          name: "Upload",
          icon: "fa-upload"
        },
        // 'new-folder': {
        // 	name: 'New Folder',
        // 	icon: 'fa-folder-open-o'
        // },
        delete: {
          name: "Delete",
          icon: "fa-trash-o"
        },
        bulk_actions: {
          name: "Bulk Actions",
          icon: "fa-toggle-on"
        }
      },
      callback: function(key, options) {
        let node;
        tree = $.ui.fancytree.getTree("#tree-pane-component");
        // node = tree.getActiveNode();
        node = ContextMenu.findContextNode(options.$trigger[0]);

        switch (key) {
          case "upload":
            CodeEditor.Uploader.open(node);
            break;
          case "new-folder":
            ContextMenu.createFolder(node);
            break;
          case "delete":
            ContextMenu.deleteElement(node);
            break;
        }
      }
    });

    // click on a level-1 folders
    $.contextMenu({
      selector: ".fancytree-folder.root-folder",
      items: {
        createFile: {
          name: "New File",
          icon: "fa-file-code-o"
        },
        createFolder: {
          name: "New Folder",
          icon: "fa-folder-open-o"
        },
        SearchFolder: {
          name: "Search This folder",
          icon: "fa-search"
        },
        uploadFile: {
          name: "Upload",
          icon: "fa-upload"
        },
        downloadFromNode: {
          name: "Download",
          icon: "fa-download"
        }
      },
      callback: function(key, options) {
        let fileType;
        let node;
        tree = $.ui.fancytree.getTree("#tree-pane-component");
        node = ContextMenu.findContextNode(options.$trigger[0]);
        fileType = CodeEditor.Main.fileType(node);
        switch (key) {
          case "createFile" || "downloadFromNode":
            ContextMenu[key](node, fileType);
            break;
          case "uploadFile":
            if (node.key !== "assets") {
              ContextMenu[key](node);
            } else {
              CodeEditor.UI.notif().error({ message: "Direct uploads to assets folder disabled." });
            }
            break;
          default:
            ContextMenu[key](node);
        }
      }
    });

    // Right click on a sub-folder
    $.contextMenu({
      selector: ".fancytree-lastsib ul .fancytree-folder",
      items: {
        createFile: {
          name: "New File",
          icon: "fa-file-code-o"
        },
        createFolder: {
          name: "New Folder",
          icon: "fa-folder-open-o"
        },
        editElement: {
          name: "Rename",
          icon: "fa-edit"
        },
        SearchFolder: {
          name: "Search This folder",
          icon: "fa-search"
        },
        uploadFile: {
          name: "Upload",
          icon: "fa-upload"
        },
        downloadFromNode: {
          name: "Download",
          icon: "fa-download"
        },
        deleteElement: {
          name: "Delete",
          icon: "fa-trash-o"
        }
      },
      callback: function(key, options) {
        let node = ContextMenu.findContextNode(options.$trigger[0]);
        let fileType = CodeEditor.Main.fileType(node);
        switch (key) {
          case "createFile" || "downloadFromNode":
            ContextMenu[key](node, fileType);
            break;
          default:
            ContextMenu[key](node);
        }
      }
    });
  };

  ContextMenu.createFile = function(node, file_type, newNode) {
    if (newNode) {
      node.setExpanded();
      node.toggleSelected();
      node.editCreateNode("child", {
        key: "",
        file_type: file_type,
        original_content: newNode.data.original_content,
        title: newNode.title,
        folder: newNode.folder ? true : false,
        extraClasses: newNode.folder ? "fodler" : "file"
      });
      return;
    }
    let suggest = "untitled.liquid";
    const path = node.getPath();
    if (file_type === "asset") {
      if (path.includes("javascripts")) {
        suggest = "untitled.js";
      } else if (path.includes("stylesheets")) {
        suggest = "untitled.scss";
      }
    } else if (path.split("/")[1] === "snippets") {
      suggest = "_untitled.liquid";
    }
    node.setExpanded();
    let modal = ContextMenu.modal("dark-theme");
    const normalizedPath = CodeEditor.Tree.getNodePath(node);

    let contentHTML = `
    <p>Choose a file name followed by an extension</p>
    <code>${normalizedPath}/</code>
    <form class='modal_form flex flex-vertical-center' id='form_new_file'>
      <input id='new_file' value='${suggest}' class='form-control m0' />
      <button type="submit" class="tingle-btn tingle-btn--primary tingle-btn--pull-right">Create</button>
    </form>`;
    modal.setContent(contentHTML);
    $("#form_new_file").on("submit", function(e) {
      e.preventDefault();
      e.stopPropagation();
      let new_title = $("#new_file").val();
      if (validFilename(new_title)) {
        node.toggleSelected();
        node.editCreateNode("child", {
          key: "",
          file_type: file_type,
          title: new_title,
          folder: false,
          extraClasses: "file"
        });

        modal.destroy();
      } else {
        let notification = CodeEditor.UI.notif();
        notification.error({
          message: "filename must be of valid format! <b>" + new_title + "</b> is not valid!"
        });
      }
    });
    modal.open();
    $("#new_file").select();
  };

  ContextMenu.createFolder = function(node) {
    node.setExpanded();
    node.toggleSelected();
    const newFolderName = getFolderNameSuggestion(node);
    node.editCreateNode("child", {
      key: "",
      folder: true,
      title: newFolderName,
      children: [],
      checkbox: false
    });
  };

  ContextMenu.editElement = function(node) {
    node.setExpanded();
    let modal = ContextMenu.modal("dark-theme");
    let contentHTML = `
    <div class='body'>
      <p>Change the name file of <code>"${node.title}"</code></p>
      <form class='modal_form flex flex-vertical-center' id='form_new_name'>
        <input id='new_name_input' class='form-control m0' type='text' name='new_name' value="${node.title}">
        <button type="submit" class="tingle-btn tingle-btn--primary tingle-btn--pull-right">Rename</button>
      </form>
    </div>`;
    modal.setContent(contentHTML);
    $("#form_new_name").on("submit", function(e) {
      e.preventDefault();
      e.stopPropagation();
      const form_new_name = document.getElementById("form_new_name");
      let newName = form_new_name.children.new_name_input.value;
      let validFilename = require("./utils").validFilename;
      if (validFilename(newName)) {
        node.editStart();
        $("input.fancytree-edit-input").val(newName);
        node.editEnd(true);
        modal.destroy();
        document.body.focus();
      } else {
        let notification = CodeEditor.UI.notif();
        notification.error({
          message: "Folder/file name must be of valid format! <b>" + newName + "</b> is not valid!"
        });
      }
    });

    modal.open();
    $("#new_name_input").select();
  };

  /**
   * Creates new nodes from uploaded files
   */
  ContextMenu.uploadFile = async function(parentNode) {
    const uploadedFiles = await CodeEditor.Uploader.upload(parentNode.data.path);

    /*
      This is called by the newly created node.
     */
    parentNode.notify = newNode => {
      const uploadedFile = uploadedFiles.find(file => {
        return file.reference === newNode.data.reference;
      });

      if (uploadedFile) {
        CodeEditor.Main.saveFile(newNode, uploadedFile.name, uploadedFile.content);
      }
    };

    uploadedFiles.forEach(file =>
      parentNode.editCreateNode("child", {
        key: "",
        file_type: "asset",
        title: file.name,
        folder: false,
        extraClasses: "file",
        original_content: "/* [placeholder-content] */" // This to let the save module know we are saving un uploaded file
      })
    );
  };

  ContextMenu.downloadFromNode = async function(node, file_type) {
    CodeEditor.UI.notif({
      id: "download_node",
      message: "perparing to download <b>" + node.title + "</b>",
      timeout: 100000
    });
    try {
      const { default: JSZip } = await import(/* webpackChunkName: "jsZip" */ "jszip");
      let zip = new JSZip();
      if (!node.children && !node.folder) {
        CodeEditor.Main.loadFile(
          node,
          file_type,
          node.path,
          async function(node, data) {
            let content = new Blob([data], { type: "text/plain;charset=utf-8" });
            saveAs(content, node.title);
          },
          true
        );
        return true;
      }
      if (node.children) {
        const crawlFolderDescendants = async function(folderNode, folderName) {
          if (folderNode.children) {
            await Promise.all(
              folderNode.children.map(async node => {
                if (!node.data.tephra) {
                  folderName = folderName ? (folderName.endsWith("/") ? folderName : folderName + "/") : "";
                  if (node.folder) {
                    await crawlFolderDescendants(node, folderName + node.title);
                  } else {
                    const loadFile = async () =>
                      await CodeEditor.Main.loadFile(
                        node,
                        CodeEditor.Main.fileType(node),
                        node.path,
                        async function(node, data) {
                          zip.file(folderName + node.title, await data);
                        },
                        true
                      );
                    try {
                      await loadFile();
                    } catch (error) {
                      console.log("This node failed:", node);
                      console.log("retrying to fetch for the same node");
                      setTimeout(async () => {
                        await loadFile();
                      }, 1000);
                    }
                  }
                }
              })
            );
          }
        };
        let test = crawlFolderDescendants(node);
        Promise.resolve(test).then(function() {
          zip.generateAsync({ type: "blob" }).then(function(content) {
            saveAs(content, node.title + ".zip");
          });
        });
        return true;
      }
    } catch (error) {
      console.error(error);
    }
  };

  /**
   * A move function is basically, creating a new file that mimics the
   *  original file into the desired directory and deleting the old file
   *  so you have one record of the file
   * @function ContextMenu.moveElement
   * @param  {Object} sourceNode
   * @param  {Object} path
   * @return {Boolean}
   */
  ContextMenu.moveElement = function(sourceNode, path) {
    let sourceNodeContent;
    const targetFolder = CodeEditor.Tree.getNodeByPath(
      path
        .split("/")
        .slice(0, -1)
        .join("/")
    );
    const tempKey = CodeEditor.GUID();
    if (!targetFolder) {
      // debugger;
    }
    if (targetFolder) {
      console.log("targetFolder", targetFolder);
      targetFolder.addNode({
        title: path.split("/").last(),
        extraClasses: "placeholder-node move-node",
        key: tempKey,
        data: {
          refToKey: sourceNode.data.secure_random
        }
      });
    }
    // load the source file
    CodeEditor.Main.loadFile(
      sourceNode,
      sourceNode.data.file_type,
      sourceNode.data.path,
      (node, content) => {
        // get the source file's content to add it to the new file
        sourceNodeContent = content ? content : "";
        // create the new file in the new directory
        CodeEditor.Main.createFile(
          {
            path: path,
            reference: CodeEditor.Main.generateReference(path),
            file_type: CodeEditor.Main.fileType(path),
            content: sourceNodeContent
          },
          () => {
            // when done delete the old file
            ContextMenu.deleteElement(sourceNode, true).then(() => {
              //  tree.getNodeByKey(tempKey).remove();
              CodeEditor.Tree.reload();
            });
          }
        );
      },
      true // passive
    );
    return false;
  };

  ContextMenu.deleteElement = function(node, passive, callback) {
    const filePath = CodeEditor.Tree.getNodePath(node);
    const filetype = CodeEditor.Main.fileType(node);
    const deleteRequest = () => {
      const notification = CodeEditor.UI.notif({
        id: "delete_node",
        message: "deleting <b>" + node.title + "</b>",
        timeout: 100000
      });
      return $.ajax({
        type: "delete",
        url: "/api/v1/code_editor/delete",
        headers: {
          "x-csrf-token": $("meta[name='csrf-token']").attr("content")
        },
        data: {
          file_type: filetype,
          secure_random: node.data.secure_random,
          theme_id: CodeEditor.Main.themeId(),
          socket_id: window.socketId
        },
        success: function(data) {
          if (data.success === true) {
            addTrail(`Deleted ${node.data.reference} successfully`);
            document.getElementById(filePath) && Tabs.close(filePath);
            node.remove();
            node = null;
            notification.destroy($("#delete_node")[0]);
            console.log("Delete confirmed!");
            CodeEditor.Main.refreshContent();
            CodeEditor.Tree.reload();
            typeof callback == "object" && callback.success == "function" && callback.success();
            return true;
          }
          typeof callback == "object" && typeof callback.fail == "function" && callback.fail();
          return false;
        },
        error: function() {
          notification.destroy({}, $("#delete_node")[0]);
          notification.error({
            message: "Error on delete " + node.title + " file, please contact a Ixcanul manager. Check console.",
            timeout: 2000
          });
        }
      });
    };
    $(document.body).focus();
    if (passive) {
      return deleteRequest().then(() => {
        tree.setFocus();
      });
    }
    let modal = ContextMenu.modal("dark-theme");
    modal.open();
    modal.setContent("<p>You are going to delete:</p><code>" + node.title + "</code><p>Do you want to continue?</p>");

    modal.addFooterBtn("Delete", "tingle-btn tingle-btn--primary tingle-btn--pull-right", function() {
      deleteRequest().then(() => {
        tree.setFocus();
        modal.destroy();
      });
    });
    modal.addFooterBtn("Cancel", "tingle-btn tingle-btn--default tingle-btn--pull-right", function() {
      modal.destroy();
      tree.setFocus();
    });
  };

  // depricate
  ContextMenu.modal = classes => {
    let $tingle = require("tingle.js");
    let modal = new $tingle.modal({
      footer: true,
      stickyFooter: false,
      closeMethods: ["overlay", "button", "escape"],
      closeLabel: "Close",
      cssClass: (classes + " mw_ixcanul").split(" "),

      onOpen: () => {
        $(".tingle-modal--visible")[0].focus();
        let $forms = $(".tingle-modal--visible").find("form");
        let $primarybtn = $(".tingle-modal--visible").find(".tingle-btn--primary");
        if ($forms.length === 0) {
          if ($primarybtn.length > 0) {
            $primarybtn.trigger("focus");
          }
        }
        console.log("modal open");
        console.log(modal);

        Mousetrap(document.body).bind(["esc", "escape"], function() {
          modal.destroy();
          return false;
        });
        // Mousetrap(document.body).bind('enter', function(e) {
        //   return false;
        // });
        $(".tingle-modal--visible").off("click.ixcanulModal");
        $(".tingle-modal--visible").on("click.ixcanulModal", function(e) {
          if (e.target.classList && e.target.classList.contains("tingle-modal--visible")) {
            modal.destroy();
          }
        });
      },
      onClose: () => {
        console.log("modal closed");
        if (tree.getActiveNode !== null) {
          tree.setFocus();
        }
      },
      beforeOpen: () => {
        console.log("beforeOpen");
      },
      beforeClose: () => {
        console.log("beforeClose");
      }
    });
    return modal;
  };

  ContextMenu.fileHistory = node => {
    console.log(node);

    const fileHistory = new CodeEditor.fileHistory(node);
    fileHistory.init(node);
    return fileHistory;
  };

  // File search opener
  ContextMenu.fileSearch = () => {
    const Fuse = require("fuse.js");
    const options = {
      shouldSort: true,
      matchAllTokens: true,
      includeMatches: true,
      threshold: 0.4,
      location: 0,
      distance: 100,
      maxPatternLength: 32,
      minMatchCharLength: 3,
      keys: ["path"]
    };
    let modal = ContextMenu.modal("file-search dark-theme no-footer");
    let treeData = JSON.parse(localStorage.getItem("files_list"));
    const fuse = new Fuse(treeData, options); // "list" is the item array
    const highlightMatches = match => {
      const { indices, value } = match;
      let str = value;
      const index = indices.last();
      const range = [index[0], index[1] === index[0] ? index[1] + 1 : index[1]];
      str =
        str.substring(0, range[0]) +
        `<span class="highlight">${str.substring(range[0], range[1] + 1)}</span>` +
        str.substring(range[1] + 1, str.length);
      return str;
    };
    modal.open();
    modal.setContent(
      "<p>Find and open a file</p><input id='file-opener-input' class='form-control' ><div class='search-results select-list' id='file_opener_results'></div>"
    );
    $("#file-opener-input")[0].focus();
    modal.addFooterBtn("Cancel", "tingle-btn tingle-btn--default tingle-btn--pull-right", function() {
      // avoid memory leaks or detached events
      $("#file-opener-input").off();
      modal.destroy();
    });
    $("#file-opener-input").on("keydown", ({ key }) => {
      if (!$("#file_opener_results .select-list-item").length) {
        return true;
      }
      const activeItem = $("#file_opener_results .select-list-item.active");
      const items = activeItem.parent().children();
      if (activeItem.length && (key === "ArrowUp" || key === "ArrowDown")) {
        activeItem.removeClass("active");
        const currentIndex = activeItem.index();
        const index =
          key === "ArrowUp"
            ? currentIndex - 1
            : key === "ArrowDown"
            ? currentIndex >= items.length - 1
              ? 0
              : currentIndex + 1
            : 0;
        const target = items.get(index);
        target.classList.add("active");
        if (currentIndex > 7) {
          const file_opener_results = document.getElementById("file_opener_results");
          const nextScrollY =
            target.offsetTop - (file_opener_results.offsetTop + file_opener_results.offsetHeight * 0.8);
          file_opener_results.scroll(0, nextScrollY);
        }
        return true;
      }
      (key === "ArrowUp" || key === "ArrowDown") &&
        $("#file_opener_results .select-list-item")
          .first()
          .addClass("active");
    });
    $("#file-opener-input").keyup(({ key }) => {
      if (key === "ArrowUp" || key === "ArrowDown") {
        return true;
      }
      if (key === "Enter") {
        let activeItem = $("#file_opener_results .select-list-item.active").data();
        if (!activeItem) {
          activeItem = $("#file_opener_results .select-list-item:first-of-type").data();
        }
        const node = tree.getNodeByKey(activeItem.node_id);
        CodeEditor.Tree.openFile(null, node);
        modal.destroy();
        return false;
      }
      if ($("#file-opener-input").val().length > 2 && treeData != null) {
        let keyword = $("#file-opener-input").val();
        const results = fuse.search(keyword).reverse();
        $("#file_opener_results").empty();
        results.forEach(result => {
          const { item, matches } = result;
          const isTephra = /^tephra/.test(item.path);
          const path = matches.map(match => highlightMatches(match)).join("");
          let $resultDom = [];
          if (isTephra) {
            const folder = tree.getNodeByKey(item.secure_random + "-folder");
            $resultDom = folder.children.map(({ data }) => {
              return $(
                '<div class="search-item select-list-item">' +
                  data.path.split("/").last() +
                  `<span class="path">${path}</span>` +
                  "</div>"
              ).data("node_id", data.secure_random);
            });
          } else {
            $resultDom = [
              $(
                '<div class="search-item select-list-item">' +
                  item.path.split("/").last() +
                  `<span class="path">${path}</span>` +
                  "</div>"
              ).data("node_id", item.secure_random)
            ];
          }

          $("#file_opener_results").prepend(...$resultDom);
          $resultDom.forEach(element => {
            element.on("click", function() {
              let node = tree.getNodeByKey($(this).data("node_id"));
              if (node.children) node = node.children.find(({ key }) => key === node.key);
              CodeEditor.Tree.openFile(null, node);
              element.off();
              modal.destroy();
            });
          });
        });
        window._prevKeyword = $("#file-opener-input").val();
        window._prevResults = results;
      } else {
        $("#file_opener_results").empty();
        [window._prevResults, window._prevKeyword] = [null];
      }
    });
  };

  ContextMenu.getNodeProperties = node => {
    let bind;
    let modal = CodeEditor.UI.modal("dark-theme nerds no-footer", "node_properties");
    propertiesView.node = node;
    modal.open();
    bind = hyperHTML.bind(document.querySelector(".tingle-modal-box__content"));
    bind`${propertiesView.render()}`;
  };

  ContextMenu.SearchFolder = node => {
    if (node.folder) {
      CodeEditor.SearchFolder.attachNode(node);
      CodeEditor.SearchFolder.show();
    }
  };

  ContextMenu.previewSnippet = async node => {
    const nodeHash = node.data.secure_random.replace(/-folder|-liquid|-scss|-js/, "");
    let modal = CodeEditor.UI.modal("dark-theme nerds no-footer", "node_properties");
    modal.open();
    $(".tingle-modal-box__content").append(
      `<iframe src="/api/v1/tephra_snippets/${nodeHash}/preview?theme_id=${CodeEditor.Main.themeId()}" width="100%" height="500" ></iframe>`
    );
  };
  ContextMenu.findContextNode = triggerNode => {
    triggerNode.classList.add("context-menu-trigger");
    let _nodeFinderCallback = node => node.span && node.span.classList.contains("context-menu-trigger");
    let node = tree.findFirst(_nodeFinderCallback);
    if (node !== null) {
      node.setActive().then(() => {
        $(triggerNode).removeClass("context-menu-trigger");
      });
    } else {
      node = tree.getActiveNode();
      $(triggerNode).removeClass("context-menu-trigger");
    }
    console.log("node:", node);
    return node;
  };

  ContextMenu.replaceThemeFiles = () => {
    CodeEditor.Main.replaceTheme();
  };
  ContextMenu.reloadTree = () => {
    CodeEditor.Tree.reload();
  };

  return ContextMenu;
})();
